if ( $('body.article').length > 0 ) {
  // 記事のお気に入りボタンのアニメーション
  $('.bookmark__button').click( function() {

    if ( $('.bookmark').hasClass('swashOut') ) {
      $('.bookmark').removeClass('swashOut');
    } else {
      $('.bookmark').addClass('swashOut');
      $('.bookmark').on('animationend',function() {
        $('.bookmark').removeClass('swashOut');
        $('.bookmark__button').removeClass('icon-bookmark-plus').addClass('icon-bookmark-check');
        $('.bookmark').addClass('swashIn');
      });
    }

  });

  // 記事の目次を自動生成する
  function generateToc () {
    var $tocWrap = $('.toc');
    if ($tocWrap.length > 0) {
      var $tocList = $('.toc__list');
      var $allEntries = $('.entry__head');

      if ($allEntries.length > 0) {

        $allEntries.each(function(index, entry) { // IEの為ArrayのforEachを使う
          var $item = $('<li/>');
          var $link = $('<a/>');
          var lang = $(this).closest('[id*="lang_"]')[0].id.split('_')[1];

          $item.addClass('toc__item toc__item--' + lang);
          $link.addClass('toc__item-link');
          $link.text(entry.textContent);
          $link.attr('href', '#entry-' + lang + '-' + Number(index) );
          $item.append($link);
          $tocList.append($item);

          entry.setAttribute( 'id', 'entry-' + lang + '-' + Number(index) );
        });
      } else {
        $($tocWrap).hide();
      }
    } else {
      return;
    }

  }
  generateToc();
}
